// extracted by mini-css-extract-plugin
export default {"riskAlertMessage":"dn4lAvJbq1ggw6CwzAWt"};